import { angryDocks, ghostCount, ghostedDocks, satisfiedButGhostedDocks } from '../../../Game/GamePlayerInfo';
import WeightedChoiceBase from './WeightedChoiceBase';

export default class ShouldIChooseGhost extends WeightedChoiceBase {

    constructor(gameController, aiPackage) {
        super(gameController, aiPackage);
        this.ghostedDocks = ghostedDocks(this._gamePlayerData);
        this.isDockZeroGhosted = this.ghostedDocks.includes(0);
        this.totalGhostCount = ghostCount(this._gamePlayerData);
        this.angryDocks = angryDocks(this._gamePlayerData);
        this.satisfiedDocks = satisfiedButGhostedDocks(this._gamePlayerData);

    }

    _novice = (recursive=false) => {
        if (!recursive) this._aiPackage.addProvenance(
            'What is my Affinity with Ghost', 'Novice');
        let weight = 0;

        let question = 'Is Dock 0 Ghosted?';
        let answer = false;
        let reasoning = 'Always keep Dock 0 available.';
        if (this.isDockZeroGhosted){
            weight += 3;
            answer = true;
        }
        this._aiPackage.addProvenance(question, answer, reasoning);
        this._weight += weight
    }

    _reasonable = (recursive=false) => {
        if (!recursive) this._aiPackage.addProvenance(
            'What is my Affinity with Ghost', 'Reasonable');

        let weight = 0

        let question = 'Is Dock 0 Ghosted?';
        let answer = false;
        let reasoning = 'Always keep Dock 0 available.';
        if (this.isDockZeroGhosted){
            weight += 3;
            answer = true;
        }
        this._aiPackage.addProvenance(question, answer, reasoning);

        question = 'How many Angry Ghosts do I have?';
        answer = 0;
        reasoning = `I would like 0, I have ${this.angryDocks.length}.`;
        if (this.angryDocks.length > 0) {
            weight += this.angryDocks.length;
            answer = true;
        }
        this._aiPackage.addProvenance(question, answer, reasoning);
        if (weight > 5) {
            weight = 5
        }
        this._weight += weight
    }

    _persistent = () => {
        this._aiPackage.addProvenance(
            'What is my Affinity with Ghost', 'Persistent');
        this._reasonable(true);
        if (this._weight < 1) {
            this._weight = 1
        }
    }
    _unreasonable = () => {
        this._aiPackage.addProvenance(
            'What is my Affinity with Ghost', 'Unreasonable');
        this._reasonable(true);
        if (this._weight < 2) {
            this._weight = 2
        }

    }

    _obsessed = () => {
        this._aiPackage.addProvenance(
            'What is my Affinity with Ghost', 'Obsessed');
        this._reasonable(true);
        if (this._weight < 3) {
            this._weight = 3
        }
    }
}
